import { Tooltip, Typography, Checkbox, Box } from "@mui/material";

export default function CheckBoxTableRow(props: {
  name?: string;
  active: boolean;
  onChange:
    | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
    | undefined;
  disabled?: boolean;
  flexDirection?: string;
}) {
  const { name, active, onChange, disabled, flexDirection } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: flexDirection ?? { xs: "column", md: "row" },
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          color: disabled ? "rgba(217, 217, 217, 0.5)" : "#FFF",
        }}
      >
        {name ?? ""}
      </Typography>
      <Tooltip
        title={name ? `${active ? "Desabilitar" : "Habilitar"} ${name}` : ""}
      >
        <Checkbox disabled={disabled} checked={active} onChange={onChange} />
      </Tooltip>
    </Box>
  );
}
